import { APISession } from './session'
import { LLMServiceType } from './services'

export interface PromptServiceConfig {
  Text: string | null
  ServiceType: LLMServiceType
}

export interface PromptConfig {
  LegislativeReview?: PromptServiceConfig | null
  Opposition?: PromptServiceConfig | null
  Support?: PromptServiceConfig | null
  ShouldMonitor?: PromptServiceConfig | null
}

export interface AIMonitorConfig {
  MonitoringEnabled: boolean
  Thresholds: {
    overall: number
    direct_umcp: number
    indirect_umcp: number
    direct_higher_ed: number
    indirect_higher_ed: number
  }
  CostControl: 'full_text' | 'synopsis'
  PromptText?: string
  PromptConfig?: {
    PromptText?: string
  }
}

export const defaultMonitorConfig: AIMonitorConfig = {
  MonitoringEnabled: false,
  Thresholds: {
    overall: 8,
    direct_umcp: 8,
    indirect_umcp: 8,
    direct_higher_ed: 8,
    indirect_higher_ed: 8
  },
  CostControl: 'synopsis'
}

export type DataSource = 'Maryland' | 'Federal'

export interface Config {
  PK: string
  SK: string
  ActiveSession: APISession
  EnableSyncJob?: boolean
  Prompts?: PromptConfig
  AIMonitor?: AIMonitorConfig
  DataSource?: DataSource
}